import {SET_ECF_Received_Data,SELECT_ROW_ECF_RECEIVED,RESET_ECF_RECEIVED} from '../../../../constants/ActionTypes'
const InitialState={
    DataTable:[],
}

function ReceivedECF(state = InitialState, action) {
    switch (action.type) {
        case SET_ECF_Received_Data:
                        return {
                            ...state,
                            DataTable: action.payload.map((x,index)=>({
                                ...x,
                                providerCode:x.providerCode,
                                rncEmisor:x.rncEmisor,
                                razonSocialEmisor:x.razonSocialEmisor,
                                fechaEmision:x.fechaEmision,
                                eNCF:x.eNCF,  
                                montoGravadoTotal: x.montoGravadoTotal,   
                                key: index,
                                totalITBIS: x.totalITBIS,
                                montoExento:x.montoExento,
                                montoTotal:x.montoTotal
                        }))
                        }
        case SELECT_ROW_ECF_RECEIVED:
          var Index = state.DataTable.findIndex(x=>x.id ==action.payload.id );
          let  ListData = state.DataTable;
          ListData[Index].selection = !ListData[Index].selection;
            return{
                ...state,
                DataTable: ListData

            }

            case RESET_ECF_RECEIVED:
            return{
                ...state,
                DataTable:[]
            }

            default:
            return state;    
    }
    
}


export default ReceivedECF;